function GetStarted(props) {
    return (
        <>
            <section className={"benefitSec " + props?.descClass}>
                <div className="container">
                    <div className="row">
                        {props?.mainImg && (
                            <div className="col-md-6">
                                <figure className='benefitImg'>
                                    <img src={process.env.PUBLIC_URL + "/images/" + props.mainImg} alt=""/>
                                </figure>
                            </div>
                        )}
                        <div className="col-md-6">
                            <div className="content">
                                <div className="title">
                                    {props?.heading && (
                                        <h2 className="secHeading" data-aos='fade-up'>
                                            {props?.heading}
                                        </h2>
                                    )}
                                    {props?.description.map((para, index) => (
                                        <p key={index} className={"description " + props?.descClass} data-aos='fade-up'
                                           data-aos-delay='100'>
                                            {para}
                                        </p>
                                    ))}
                                </div>
                                {props?.listing && (
                                    <ul className="benefitList">
                                        {props?.listing.map((list) => (
                                            <li key={list.id}> {/* Use a unique identifier like 'list.id' as the key */}
                                                <figure>
                                                    <img src={process.env.PUBLIC_URL + '/images/' + list.img} alt=""/>
                                                </figure>
                                                <div className="content">
                                                    <h5>{list?.title}</h5>
                                                    <p>{list?.content}</p>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default GetStarted